// src/pages/NotreHistoire.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoImg from '../assets/logo.jpeg';   // ⬅️ AJOUT IMPORT

function NotreHistoire() {
  const { t } = useTranslation();

  return (
    <main className="story-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <span className="page-hero__label">{t('story.heroLabel')}</span>
          <h1 className="page-hero__title">{t('story.heroTitle')}</h1>
          <p className="page-hero__subtitle">{t('story.heroSubtitle')}</p>
        </div>
      </header>

      <section className="story-intro">
        <div className="story-intro__inner">
          <div className="story-intro__img">
            <img src={logoImg} alt={t('story.introAlt')} />  {/* ⬅️ CHANGÉ */}
          </div>
          <div className="story-intro__text">
            <h2>{t('story.introHeading')}</h2>
            <p>{t('story.introP1')}</p>
            <p>{t('story.introP2')}</p>
          </div>
        </div>
      </section>

      <section className="story-values">
        <header>
          <span className="story-values__label">{t('story.valuesLabel')}</span>
          <h2>{t('story.valuesTitle')}</h2>
        </header>
        <div className="story-values__grid">
          <div className="story-value">
            <div className="story-value__icon">🕌</div>
            <h3>{t('story.value1Title')}</h3>
            <p>{t('story.value1Text')}</p>
          </div>
          <div className="story-value">
            <div className="story-value__icon">🇲🇦</div>
            <h3>{t('story.value2Title')}</h3>
            <p>{t('story.value2Text')}</p>
          </div>
          <div className="story-value">
            <div className="story-value__icon">✨</div>
            <h3>{t('story.value3Title')}</h3>
            <p>{t('story.value3Text')}</p>
          </div>
        </div>
      </section>

      <section className="story-cta">
        <h2>{t('story.ctaTitle')}</h2>
        <p>{t('story.ctaText')}</p>
        <Link to="/boutique" className="btn btn-primary">
          {t('story.ctaButton')}
        </Link>
      </section>
    </main>
  );
}

export default NotreHistoire;